import { createTheme, responsiveFontSizes } from '@mui/material';
import { primaryColorObj, secondaryColorObj } from '.';

const buildTheme = t =>
  responsiveFontSizes(
    createTheme({
      zIndex: {
        drawer: 1009,
      },
      typography: {
        fontFamily: [
          'Ubuntu',
          'BlinkMacSystemFont',
          '-apple-system',
          'Segoe UI',
          'Roboto',
          'Oxygen',
          'Ubuntu',
          'Cantarell',
          'Fira Sans',
          'Droid Sans',
          'Helvetica Neue',
          'Helvetica',
          'Arial',
          'sans-serif',
        ].join(','),
      },
      palette: {
        text: {
          primary: '#FFFFFF',
          secondary: '#040E20',
        },
        primary: {
          main: primaryColorObj.default,
        },
        secondary: {
          main: '#114851',
        },
        background: {
          default: '#09152D',
          light: '#071734',
          paper: '#EDEBEB',
        },
      },
      components: {
        MuiCard: {
          styleOverrides: {
            root: {
              backgroundColor: '#071734',
              border: `1px solid ${primaryColorObj.default}`,
              height: '100%',
              color: '#FFFFFF',
            },
          },
        },
        MuiCardHeader: {
          styleOverrides: {
            subheader: {
              color: '#FFFFFF',
            },
          },
        },
        MuiUseMediaQuery: {
          defaultProps: {
            noSsr: true,
          },
        },
        MuiRadio: {
          styleOverrides: {
            root: {
              color: primaryColorObj.default,
            },
          },
        },
        MuiCheckbox: {
          styleOverrides: {
            root: {
              color: `${primaryColorObj.default} !important`,
            },
          },
        },
        MuiAutocomplete: {
          defaultProps: {
            clearText: t('components.autocomplete.clear'),
          },
          styleOverrides: {
            paper: {
              margin: 0,
              marginLeft: '0.09vh !important',
              paddingBottom: '0px !important',
              borderTopLeftRadius: '0px !important',
              borderTopRightRadius: '0px !important',
              color: '#586069 !important',
            },
            option: {
              '&[aria-selected="true"]': {
                backgroundColor: '#02BDBD !important',
                color: '#FFFFFF',
              },
              '&.Mui-focused': {
                backgroundColor: '#039e9e !important',
                color: '#FFFFFF',
              },
            },
          },
        },
        MuiInput: {
          styleOverrides: {
            input: {
              color: '#040E20',
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              color: '#040E20',
              '&:hover fieldset': {
                borderColor: `${primaryColorObj.default} !important`,
              },
            },
          },
        },
        MuiTooltip: {
          styleOverrides: {
            tooltip: {
              backgroundColor: secondaryColorObj.default,
              fontSize: '0.90rem',
              padding: '0.75em 1em',
              textAlign: 'center',
              fontWeight: '500',
              border: `1px solid ${primaryColorObj.default}`,
            },
            arrow: {
              '&::before': {
                border: `1px solid ${primaryColorObj.default}`,
                backgroundColor: secondaryColorObj.default,
                boxSizing: 'border-box',
                borderRadius: '2px',
              },
            },
          },
        },
        MuiMenu: {
          styleOverrides: {
            paper: {
              backgroundColor: secondaryColorObj.default,
              border: `1px solid ${primaryColorObj.default}`,
            },
          },
        },
      },
    }),
  );

export default buildTheme;
